// cn() — the canonical Govard className merger.
//
// Combines `clsx` (conditional class composition) with `tailwind-merge`
// (resolves Tailwind utility conflicts — e.g. `px-2` + `px-4` → `px-4`).
// Every primitive component merges user-supplied `className` through this
// helper so consumers can safely override styles.

import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
